import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const cache = {};
const load = (key, url) => {
  cache[key] = cache[key] || api.get(url).then((r) => r.data).catch(() => { delete cache[key]; return key === "assignees" ? [] : {}; });
  return cache[key];
};

export const useLookups = () => {
  const [d, setD] = useState({});
  useEffect(() => { load("lookups", "/crm/lookups").then(setD); }, []);
  return d;
};

export const useAssignees = () => {
  const [d, setD] = useState([]);
  useEffect(() => { load("assignees", "/crm/assignees").then(setD); }, []);
  return d;
};

export const labelOf = (list, key) => (list || []).find((x) => x.key === key) || { label: key || "—", tone: "neutral" };

export const NONE = "__none";

export const SelectField = ({ label, value, onChange, options, placeholder = "Seleziona", allowNone, testId, className }) => (
  <div className={className ? `space-y-1.5 ${className}` : "space-y-1.5"}>
    {label && <Label className="text-xs">{label}</Label>}
    <Select value={value || (allowNone ? NONE : undefined)} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
      <SelectTrigger className="h-9" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {allowNone && <SelectItem value={NONE}>{typeof allowNone === "string" ? allowNone : "—"}</SelectItem>}
        {(options || []).map((o) => <SelectItem key={o.key || o.id} value={o.key || o.id}>{o.label || o.name}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const Pager = ({ page, pages, total, onPage, unit = "risultati" }) => (
  <div className="mt-4 flex items-center justify-between text-sm text-slate-500">
    <span data-testid="list-total">{total} {unit}</span>
    <div className="flex items-center gap-2">
      <button disabled={page <= 1} onClick={() => onPage(page - 1)} className="rounded-control border border-line px-3 py-1 disabled:opacity-40" data-testid="list-prev">Precedente</button>
      <span>{page} / {pages}</span>
      <button disabled={page >= pages} onClick={() => onPage(page + 1)} className="rounded-control border border-line px-3 py-1 disabled:opacity-40" data-testid="list-next">Successiva</button>
    </div>
  </div>
);
